import actions from './actions';
import mutations from './mutations';
import { VIEW_TYPES } from '../../../constants';
import sessionManager from '../session/sessionManager';

const state = {
  // CSAdmin = 4, GroupAdmin = 3, ClientAdmin = 2, ClientUser = 1, NotAuthenticated = 0
  role: 0,
  originalAdminRole: 0,
  siteType: 0,
  viewType: VIEW_TYPES.CLIENT,
  draftMode: false
};

// The following defines the permissions table, with the name representing the function
// the number representing the site type
// the array collection representing the permitted permissions
const allAccessTable = {
  onoffaccessTable: {
    1: [4, 3, 2],
    2: [4, 3], // Remove this line to lock down on/off for group children sites
    3: [4, 3]
  },
  onoffmessageaccessTable: {
    // 2: [4, 3, 2] // Enable this line to lock down on/off for group children sites
    2: [2]
  },
  singlecontexteditTable: {
    1: [4, 3, 2],
    2: [4, 3, 2],
    3: [4, 3]
  },
  contextviewaccessTable: {
    1: [4, 3, 2],
    2: [4, 3, 2],
    3: [4, 3]
  },
  processupdatesaccessTable: {
    1: [4, 3, 2],
    2: [4, 3, 2],
    3: [4, 3]
  },
  groupAdminViewTable: {
    3: [4, 3]
  }
};

const role = (stateData) => stateData.role || sessionManager.getUserRoleFromLocalStorage();

const getters = {
  auth0Enabled: (...args) => args[3]['auth0/enabled'],
  isLoggedIn: (...args) => {
    const auth0Enabled = args[3]['auth0/enabled'];
    return auth0Enabled
      ? args[3]['cs-session/isLoggedIn'] && role(args[0]) > 0
      : args[3]['session/isAuthenticated']() && role(args[0]) > 0;
  }, // rootGetters
  role,
  isUserValid: (stateData) => role(stateData) > 0,
  isAllowedTo: (stateData) => (minRole) => role(stateData) >= minRole,
  hasAccess: (stateData) => (accessTableName) => {
    const accessTable = allAccessTable[accessTableName];
    return accessTable[stateData.siteType]
      ? accessTable[stateData.siteType].indexOf(parseInt(role(stateData), 10)) >= 0
      : false;
  },
  isAdminDraftView: (stateData) => stateData.viewType === VIEW_TYPES.ADMIN_DRAFT,
  isClientView: (stateData) => stateData.viewType === VIEW_TYPES.CLIENT
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
